module.exports = __webpack_public_path__ + "img/mediagate-logo-black.795e683a.svg";